<template>
  <span
    class="t-indicator"
    :class="[
      `t-indicator--${type}`,
      `t-indicator--${floating}`,
      { 't-indicator--floating': floating },
    ]"
  ></span>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';
import { indicatorPositionOptions } from '../../enums';

export default {
  name: 't-indicator',

  mixins: [ColorTypeMixin],

  props: {
    floating: {
      type: String,
      default: indicatorPositionOptions.CENTER,
      validator: (value) => Object.values(indicatorPositionOptions).includes(value),
    },
  },
};
</script>
